import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Addstaff() {
  const navigate = useNavigate();

  const [staffName, setStaffName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [emailId, setEmailId] = useState('');
  const [teachers, setTeachers] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem("language")

  useEffect(() => {
    // Retrieve the mobile number from localStorage
    const storedMobileNumber = localStorage.getItem('adminmob');
    console.log("storedMobileNumber", storedMobileNumber);
    
    if (storedMobileNumber) {
      setMobileNumber(storedMobileNumber); 
    }

    fetchTeachers();
  }, []);

  const fetchTeachers = () => {
    const databaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
    fetch(databaseUrl)
      .then(response => response.json())
      .then(data => {
        if (data) {
          const teachersArray = Object.keys(data).map(key => ({
            id: key,
            ...data[key]
          }));
          setTeachers(teachersArray);
        }
      })
      .catch(error => console.error('Error fetching teachers:', error));
  };

  const handleClose = () => {
    navigate(-1); // Close the form and go back
  };

  const handleAddEmployee = () => {
    // Validation: Check if all fields are filled
    if (!staffName || !mobileNumber || !emailId) {
      alert('Please fill in all the fields before submitting.');
      return; // Prevent further execution if validation fails
    }
  
    const databaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData`;
    const firebaseUrl = `${databaseUrl}/${udiseNumber}/AttData/${mobileNumber}.json`;
  
    const employeeData = {
      Name: staffName,
      Mobno: mobileNumber,
      Email: emailId,
    };
  
    fetch(firebaseUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(employeeData),
    })
      .then((response) => {
        if (response.ok) {
          alert('Employee added successfully!');
          setStaffName('');
          setMobileNumber('');
          setEmailId('');
          fetchTeachers(); // Refresh the list of teachers
        } else {
          throw new Error('Failed to add employee');
        }
      })
      .catch((error) => {
        console.error('Error adding employee:', error);
      });
  };

  const handleEdit = (teacher) => {
    setStaffName(teacher.Name);
    setMobileNumber(teacher.Mobno);
    setEmailId(teacher.Email);
  };

  const handleDelete = (id) => {
    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${id}.json`;
    fetch(firebaseUrl, {
      method: 'DELETE',
    })
      .then((response) => {
        if (response.ok) {
          alert('Employee deleted successfully!');
          fetchTeachers(); // Refresh the list of teachers
        } else {
          throw new Error('Failed to delete employee');
        }
      })
      .catch((error) => {
        console.error('Error deleting employee:', error);
      });
  };

  return (
    <div className="main-content-of-page">
      <div
        style={{
          padding: '30px',
          maxWidth: '800px',
          margin: '0 auto',
          backgroundColor: '#f4f6f9',
          borderRadius: '10px',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          marginTop: '60px',
          border: '1px solid black',
        }}
      >
        <button
          style={{
            backgroundColor: '#dc3545',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '20px',
            marginLeft: '700px',
            marginBottom: '10px',
            fontWeight: 'bold',
          }}
          onClick={handleClose}
        >
          X
        </button>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ fontSize: '28px', fontWeight: 'bold', color: '#34495e', marginBottom: '10px' }}>
            {language==='English'?'Add Staff Details':'कर्मचारी तपशील भरा'}
          </h2>
        </div>

        <div style={{ display: 'block', flexDirection: 'column', gap: '20px' }}>
          <label htmlFor="staff-name" style={{ fontSize: '18px', color: '#34495e', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            {language==="English"? "Name of Staff":'कर्मचाऱ्याचे  नाव'}
            <input
              type="text"
              id="staff-name"
              placeholder="Name"
              value={staffName}
              onChange={(e) => setStaffName(e.target.value)}
              style={{ padding: '15px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', width: '100%', maxWidth: '450px', marginLeft: '70px' }}
            />
          </label>

          <label htmlFor="mobile-number" style={{ fontSize: '18px', color: '#34495e', fontWeight: '600', marginBottom: '8px', display: 'block' }}>
            
            {language==="English"? "Mobile Number":'मोबाईल नंबर'}
            <input
              type="text"
              id="mobile-number"
              placeholder="0000000000"
              maxLength="10"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              style={{ padding: '15px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', width: '100%', maxWidth: '450px', margin: '0 auto', marginLeft: language==="English"?'65px':'100px' }}
            />
          </label>

          <label htmlFor="email-id" style={{ fontSize: '18px', color: '#34495e', fontWeight: '600', marginBottom: '8px', display: 'block' }}>
              {language==="English"? "Email ID":'ईमेल आयडी'}
            <input
              type="text"
              id="email-id"
              placeholder="Enter Staff Email Id"
              value={emailId}
              onChange={(e) => setEmailId(e.target.value)}
              style={{ padding: '15px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', width: '100%', maxWidth: '450px', margin: '0 auto', marginLeft:language==="English"?'132px': '106px' }}
            />
          </label>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
            <button
              onClick={handleAddEmployee}
              style={{ padding: '10px 15px', fontSize: '18px', color: 'white', backgroundColor: '#1B4332', border: 'none', borderRadius: '5px', cursor: 'pointer', width: '100px', transition: 'background-color 0.3s ease', textAlign: 'center' }}
            >
              Add 
            </button>
          </div>
        </div>

      </div>
      <div style={{ margin: '35px auto' }}>
          <h3 style={{ textAlign: 'center', color: '#34495e' }}>{language==="English"?"Staff Data":'कर्मचारी'}</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: '10px', fontWeight:'bold', textAlign:'center' }}> {language==="English"? "Name of Staff":'कर्मचाऱ्याचे  नाव'}</th>
                <th style={{ border: '1px solid #ccc', padding: '10px', fontWeight:'bold', textAlign:'center' }}>{language==="English"? "Mobile Number":'मोबाईल नंबर'}</th>
                <th style={{ border: '1px solid #ccc', padding: '10px', fontWeight:'bold', textAlign:'center' }}>{language==="English"? "Email ID":'ईमेल आयडी'}</th>
                <th style={{ border: '1px solid #ccc', padding: '10px', fontWeight:'bold', textAlign:'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {teachers.map((teacher) => (
                <tr key={teacher.id}>
                  <td style={{ border: '1px solid #ccc', padding: '10px' }}>{teacher.Name}</td>
                  <td style={{ border: '1px solid #ccc', padding: '10px' }}>{teacher.Mobno}</td>
                  <td style={{ border: '1px solid #ccc', padding: '10px' }}>{teacher.Email}</td>
                  <td style={{ border: '1px solid #ccc', padding: '10px' }}>
                    <button onClick={() => handleEdit(teacher)} style={{ marginRight: '10px', backgroundColor: '#8A1538', color: 'white', border: 'none', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer' }}>
                      Edit
                    </button>

                    <button onClick={() => handleDelete(teacher.id)} style={{marginRight: '10px',  backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer' }}>
                      Delete
                    </button>

                      <button onClick={() => navigate(`/Profile?empmobile=${teacher.Mobno}&employeeName=${teacher.Name}`)} style={{ backgroundColor: '#198754c2', color: 'white', border: 'none', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer' }}>
                      More
                    </button>


                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    </div>
  );
}

export default Addstaff;